import React from 'react'
import styled from 'styled-components'
import sectionBg from '../static/images/backgrounds/article.jpg'
import SectionHeading from '../components/SectionHeading'
import { colors, media } from '../styles/vars'
import { StyledSection } from '../styles/elements'
import { Link } from 'react-router-dom'

const Container = styled(StyledSection) `
background-position:center top;
background-image:url(${sectionBg});
`
const Content = styled.div`
padding:326px 0 50px;
z-index:1;
position:relative;
${media.desktop`
padding:350px 50px 150px;
`}
`
const TextContent = styled.div`
${media.desktop`
max-width:initial;
display:inline-block;
text-align:center;
`}
`
const Paragraph = styled.p`
color:${colors.white};
font-size:2.2rem;
max-width:95%;
margin:20px auto;
text-align:justify;
line-height:1.2;

${media.desktop`
max-width:400px;
margin:20px 0;
`}
`
const ArticleLink = styled(Link) `
display:block;
background-color:${colors.lightblue};
padding: 5px 20px 2px;
width:45%;
margin:0 auto;
font-size:2.2rem;
text-align:center;
&, &:visited, &:hover{
    color:${colors.black};
    text-decoration:none;
}
${media.desktop`
display:inline-block;
width:auto;
padding:5px 40px 2px;
`}
`
const Shadow = styled.div`
position:absolute;
bottom:0;
left:0;
right:0;
height:300px;
background-color:${colors.black};
opacity:.5;
filter:blur(6px);
`
const ArticleSection = () => {
    return (
        <Container name="article">
            <Shadow />
            <Content>
                <TextContent>
                    <SectionHeading
                        title="לאן זה הולך: פעם עשו פה פופ קשוח"
                        subtitle="עמי פרידמן"
                        bgColor={colors.darkPurple}
                    />
                    <Paragraph>
                        ממייקל ג'קסון ועד פינק, מבון ג'ובי ועד טינה טרנר:
                        צלילי הדיסטורשן השתחררו מזמן מגבולות הרוקנ'רול והיו חלק בלתי נפרד
                        מעולם הפופ - עד שהחגיגה הרועשת התפוגגה. למה זה קרה?
                </Paragraph>
                    <ArticleLink to="/article/5106404">לכתבה המלאה</ArticleLink>
                </TextContent>
            </Content>
        </Container>
    )
}

export default ArticleSection;


// WEBPACK FOOTER //
// ./src/containers/ArticleSection.jsx